// Feather Icon JS
import { TrendingUp, TrendingDown } from "react-feather";

//Slider
import CategorySlider from "../../layouts/CategorySlider";

//Chart
import RevenueReportChart from "../../Chart/RevenueReportChart";
import RevenueChart from "../../Chart/RevenueChart";
import EarningLineChart from "../../Chart/EarningLineChart";
import VisitorsDonutChart from "../../Chart/VisitorsDonutChart";
import LastThreeDaysRevenueChart from "../../Chart/LastThreeDaysRevenueChart";
import TopCountriesOrdersChart from "../../Chart/TopCountriesOrdersChart";
import TopCustomersOrdersChart from "../../Chart/TopCustomersOrdersChart";
import TopVendorsOrdersChart from "../../Chart/TopVendorsOrdersChart";
import TopCountriesRevenueChart from "../../Chart/TopCountriesRevenueChart";
import TopVendorsRevenueChart from "../../Chart/TopVendorsRevenueChart";
//Hooks
import useDashboardStats from "../../hooks/useDashboardStats";
import { useNavigate } from "react-router-dom";

export default function index() {
  const { stats, analytics, loading, error } = useDashboardStats();
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* <!-- chart card section start --> */}
          <div className="col-sm-6 col-xxl-3 col-lg-6">
            <div
              className="main-tiles border-5 border-0  card-hover card o-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/order")}
            >
              <div className="custome-1-bg b-r-4 card-body">
                <div className="media align-items-center static-top-widget">
                  <div className="media-body p-0">
                    <span className="m-0">Total Revenue</span>
                    <h4 className="mb-0 counter">
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        `£${Number(analytics?.total_revenue_gbp || 0).toFixed(
                          2
                        )}`
                      )}
                      <TrendingUp size={8.5} />
                    </h4>
                  </div>
                  <div className="align-self-center text-center">
                    <i className="ri-database-2-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xxl-3 col-lg-6">
            <div
              className="main-tiles border-5 card-hover border-0 card o-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/order")}
            >
              <div className="custome-2-bg b-r-4 card-body">
                <div className="media static-top-widget">
                  <div className="media-body p-0">
                    <span className="m-0">Total Orders</span>
                    <h4 className="mb-0 counter">
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : error ? (
                        "0"
                      ) : (
                        stats.total_orders.toLocaleString()
                      )}
                      <TrendingDown size={8.5} />
                    </h4>
                  </div>
                  <div className="align-self-center text-center">
                    <i className="ri-shopping-bag-3-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xxl-3 col-lg-6">
            <div
              className="main-tiles border-5 card-hover border-0  card o-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/listofproducts")}
            >
              <div className="custome-3-bg b-r-4 card-body">
                <div className="media static-top-widget">
                  <div className="media-body p-0">
                    <span className="m-0">Total Products</span>
                    <h4 className="mb-0 counter">
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : error ? (
                        "0"
                      ) : (
                        stats.total_products.toLocaleString()
                      )}
                      <a
                        href="/productsaddorupdate"
                        className="badge badge-light-secondary grow"
                      >
                        ADD NEW
                      </a>
                    </h4>
                  </div>

                  <div className="align-self-center text-center">
                    <i className="ri-chat-3-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xxl-3 col-lg-6">
            <div
              className="main-tiles border-5 card-hover border-0 card o-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/customer")}
            >
              <div className="custome-4-bg b-r-4 card-body">
                <div className="media static-top-widget">
                  <div className="media-body p-0">
                    <span className="m-0">Total Customers</span>
                    <h4 className="mb-0 counter">
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : error ? (
                        "0"
                      ) : (
                        stats.total_customers.toLocaleString()
                      )}
                      <TrendingDown size={8.5} />
                    </h4>
                  </div>

                  <div className="align-self-center text-center">
                    <i className="ri-user-add-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Category sider */}

          {/* <!-- chart card section End --> */}

          {/* <!-- Earning chart star--> */}
          <div className="col-xl-6 col-md-12">
            <RevenueReportChart />
          </div>
          {/* <!-- Earning chart  end--> */}
          {/* <!-- RevenueChart start--> */}
          {/* <div className="col-xl-6 col-md-12">
                    <RevenueChart />
                </div> */}
          {/* <!-- LastThreeDaysRevenueChart start--> */}
          <div className="col-xl-6 col-md-12">
            <LastThreeDaysRevenueChart />
          </div>

          {/* <!-- Earning chart star--> */}
          <div className="col-xl-6">
            <EarningLineChart />
          </div>
          {/* <!-- Earning chart end--> */}

          {/* <!-- TopCountriesOrdersChart start--> */}
          <div className="col-xl-6 col-md-12">
            <TopCountriesOrdersChart />
          </div>

          {/* <!-- TopCustomersOrdersChart start--> */}
          <div className="col-xl-6 col-md-12">
            <TopCustomersOrdersChart />
          </div>

          {/* <!-- TopVendorsOrdersChart start--> */}
          <div className="col-xl-6 col-md-12">
            <TopVendorsOrdersChart />
          </div>

          {/* <!-- TopCountriesRevenueChart start--> */}
          <div className="col-xl-6 col-md-12">
            <TopCountriesRevenueChart />
          </div>
          {/* <!-- TopVendorsRevenueChart start--> */}
          <div className="col-xl-6 col-md-12">
            <TopVendorsRevenueChart />
          </div>
        </div>
      </div>
    </>
  );
}
